
import { defineComponent } from 'vue';
import BuyNft from '@/components/buyNft/index.vue';

export default defineComponent({
  components: {
    BuyNft
  }
});
